<template>
  <div class="container">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>local_activity</md-icon>
        </div>
        <h4 class="title">{{ $t("ticket.create.title") }}</h4>
      </md-card-header>
      <md-card-content>
        <md-toolbar class="md-transparent">
          <div class="md-toolbar-row">
            <div>
              <md-button
              :class="{'md-primary': tabActive === 'TICKETS', 'md-simple': tabActive !== 'TICKETS'}"
              @click="tabActive = 'TICKETS'">{{$t("ticket.create.tabs.ticket.title")}}</md-button>
              <md-tooltip md-direction="bottom">{{$t("ticket.create.tabs.ticket.tooltip")}}</md-tooltip>
            </div>
            <div>
              <md-button 
              :class="{'md-primary': tabActive === 'SUBSCRIPTIONS', 'md-simple': tabActive !== 'SUBSCRIPTIONS'}"
              @click="tabActive = 'SUBSCRIPTIONS'">{{$t("ticket.create.tabs.subscriptions.title")}}</md-button>
              <md-tooltip md-direction="bottom">{{$t("ticket.create.tabs.subscriptions.tooltip")}}</md-tooltip>
            </div>
          </div>
        </md-toolbar>
      </md-card-content>
      <!-- Tickets -->
      <md-card-content v-if="tabActive === 'TICKETS'">
        <create-tickets></create-tickets>
      </md-card-content>
      <!-- Subscriptions -->
      <md-card-content v-if="tabActive === 'SUBSCRIPTIONS'">
        <create-subscriptions></create-subscriptions>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import CreateTickets from '@/pages/Ticketera/Create/Tickets';
import createSubscriptions from '@/pages/Ticketera/Create/Subscriptions'

export default {
  components: {
    CreateTickets,
    createSubscriptions
  },
  data() {
    return {
      tabActive: "TICKETS",
    };
  }
};
</script>
